export function hasPricedPortions(item) {
  return (item.options ?? []).some((option) => {
    if (option.selectionType !== 'SINGLE' || !option.isRequired) return false;
    const priceDeltas = new Set((option.values ?? []).map((value) => Number(value.priceDelta ?? 0)));
    return priceDeltas.size > 1;
  });
}
